import { render, staticRenderFns } from "./AAuditTypeSelect.reg.vue?vue&type=template&id=4a1377f6&"
import script from "./AAuditTypeSelect.reg.vue?vue&type=script&lang=ts&"
export * from "./AAuditTypeSelect.reg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
